import haptic from '@/common/utils/haptics';
import { useEffect, useRef } from 'react';
import { useToaster } from 'react-hot-toast';

/** Vibrates once per new success/error toast (app only, see haptics.ts). */
export const ToastHaptics = () => {
  const { toasts } = useToaster();
  const seen = useRef(new Set<string>());

  useEffect(() => {
    toasts.forEach(t => {
      if (seen.current.has(t.id)) return;
      seen.current.add(t.id);
      if (t.type === 'error') haptic('error');
      if (t.type === 'success') haptic('success');
    });
  }, [toasts]);

  return null;
};

export default ToastHaptics;
